import Vue from 'vue'
import Vuex from 'vuex'

/* FOR USER PERMISSION MANAGEMENT */
import storage from './storage'
import {abilityPlugin, ability as appAbility} from './ability'
import {UserService} from "../services/user.service";
import router from "../router";
import {TokenService} from "../services/storage.service";
/* FOR USER PERMISSION MANAGEMENT */

import {auth} from './auth.module'
import {users} from './users.module'
import {goods} from './goods.module'
import {roles} from './roles.module'
import {pos} from './pos.module'
import {wholesalePos} from './wholesalePos.module'
import {posReport} from './pos.report.module'
import {promo} from './promo.module'
import {zetReport} from './zet-report.module'
import {contract} from './contract.module'
import {transaction} from './transaction.module'
import {references} from './references.module'
import {departments} from './departments.module'
import {permissions} from './permissions.module'
import {locales} from './locales'
import {employees} from './employees.module'
import {contragents} from './contragents.module'
import {warehouse} from "./warehouse.module"
import {whIncomeModule} from "./wh-income.module"
import {clients} from "./clients.module"
import {prices} from "./prices.module"
import {certificates} from "./certificate.module"
import {inventory} from "./inventory.module"
import {refunds} from "./refund.module"
import {monitoring} from "./monitoring.module";
import {expenses} from "./expenses.module";
import {wholeSaleReport} from "./wholesale.report.module"
import {saveTableOptions} from "./save-table-options.module"
import {booking} from './booking.module'
import {orderProduction} from "./orderProduction.module"
import {excel} from './order'

Vue.use(Vuex);
export const ability = appAbility;

const store = new Vuex.Store({
	plugins: [
		storage({
			storedKeys: ['token', 'rules'],
			destroyOn: ['logoutSuccess']
		}),
		abilityPlugin
	],

	modules: {
		orderProduction,
		auth,
		users,
		goods,
		roles,
		pos,
		wholesalePos,
		posReport,
		promo,
		zetReport,
		contract,
		transaction,
		references,
		departments,
		permissions,
		locales,
		employees,
		contragents,
		prices,
		warehouse,
		whIncomeModule,
		clients,
		certificates,
		inventory,
		refunds,
		monitoring,
		wholeSaleReport,
		saveTableOptions,
		booking,
		expenses,
		excel
	},

	state: {
		user: {
			permissions: []
		},
		userName:TokenService.getUserName(),
		isCashier: TokenService.getIsCashier(),
		isSeller: TokenService.getUserRoles(),
		isMonitoring: TokenService.getIsMonitoring(),
		isManager: TokenService.getIsManager(),
		isAdmin: TokenService.getIsAdmin(),
		isContragent: TokenService.getIsContragent(),
		authenticating: false,
		rules: [],
		userId: null,
		token: TokenService.getToken(),
		cashboxNumber: localStorage.getItem('cash_number'),
		userDepCurrencyName: TokenService.getDepCurrencyName(),
		userDepCurrencyCode: TokenService.getDepCurrencyCode(),
		userDepCurrencyId: TokenService.getDepCurrencyId(),
		userDepId: localStorage.getItem('dep_id'),
		authenticationErrorCode: 0,
		authenticationError: '',
		pageTitle: 'Dataprizma - ERP system'
	},

	getters: {
		loggedIn: (state) => {
			return !!state.token
		},

		authenticationErrorCode: (state) => {
			return state.authenticationErrorCode
		},

		authenticationError: (state) => {
			return state.authenticationError
		},

		authenticating: (state) => {
			return state.authenticating
		},

		userPermissions: (state) => {
			return state.user.permissions
		}
	},

	mutations: {
		loginRequest(state) {
			state.authenticating = true;
			state.authenticationError = '';
			state.authenticationErrorCode = 0
		},

		loginSuccess(state, user) {
			state.isCashier = JSON.parse(TokenService.getIsCashier());
			state.isMonitoring = JSON.parse(TokenService.getIsMonitoring());
			state.isManager = JSON.parse(TokenService.getIsManager());
			state.isAdmin = JSON.parse(TokenService.getIsAdmin());
			state.isContragent = JSON.parse(TokenService.getIsContragent());

			let formattedRules = [];
			if (user.permissions.length > 0) {
				formattedRules = user.permissions.map(perm => {
					let formattedObj = {};
					formattedObj.actions = perm.substr(0, perm.indexOf(' '));
					formattedObj.subject = perm.substr(perm.indexOf(' ') + 1);
					return formattedObj;
				})
			}
			state.rules = formattedRules;
			state.user = user;
			state.userId = user.id;
			state.token = user.token;
			state.authenticating = false;
			state.userName = TokenService.getUserName();
			state.isSeller = TokenService.getUserRoles();
			state.userDepCurrencyName = TokenService.getDepCurrencyName();
			state.userDepCurrencyCode = TokenService.getDepCurrencyCode();
			state.userDepCurrencyId = TokenService.getDepCurrencyId();
			state.userDepId = localStorage.getItem('dep_id');
		},

		loginError(state, {errorCode, errorMessage}) {
			state.authenticating = false
			state.authenticationErrorCode = errorCode
			state.authenticationError = errorMessage
		},

		logoutSuccess(state) {
			state.token = '';
			state.rules = [];
			state.userId = null;
		}
	},

	actions: {
		async login({commit, state}, userData) {
			commit('loginRequest');

			try {
				const user = await UserService.login(userData);
				await commit('loginSuccess', user);
				if (state.isSeller === 'seller') {
					router.push('/point-of-sale/before-pos');
					return true
				} else if (state.isMonitoring) {
					router.push('/reports/monitoring');
					return true
				}
				// Redirect the user to the page he first tried to visit or to the home view
				let routeHistory = router.history.current.query.redirect;
				router.push(routeHistory && routeHistory != '/pages/login' ? routeHistory : '/');
				return true
			} catch (e) {
				commit('loginError', {errorCode: e.errorCode, errorMessage: e.message});
				return false
			}
		},

		logout({commit}) {
			UserService.logout();
			commit('logoutSuccess');

			/* THIS IS TO REMOVE REFERENCES FROM SIDEBAR */
			commit('references/resetReferences');
			router.push('/pages/login')
		},

		setTitle({state}, value) {
			state.pageTitle = value
		}
	}
});

export default store;
